import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import { Provider as StoreProvider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import store from './globalstore.js';

ReactDOM.render( <StoreProvider store={store}><App /></StoreProvider>, document.getElementById('root'));

serviceWorker.unregister();
